import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { registerUser } from "../../redux/registerSlice";
import { setToken, clearError } from "../../redux/authSlice";
import { Link } from "react-router-dom";
import GoogleSignInButton from "./GoogleSignInButton";
import "./register.css";
import { useNavigate } from "react-router-dom";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const dispatch = useDispatch();
  const { loading, error: registerError, success } = useSelector((state) => state.register);
  // Google sign-in runs through googleLoginUser, which lives in the AUTH slice — so its
  // failures land in state.auth.error, not state.register.error. Reading only the register
  // slice here made every Google failure on this page silent.
  const googleError = useSelector((state) => state.auth.error);
  const error = registerError || googleError;
  const navigate = useNavigate();

  // state.auth.error is only cleared when the next login/Google attempt starts, so a failure
  // carried over from the login page would otherwise appear here unprompted on arrival.
  useEffect(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(registerUser({ email, password, userName }));
    if (registerUser.fulfilled.match(result)) {
      dispatch(setToken(result.payload));
      navigate("/home");
    }
    
  };

  return (
    <div className="register-container">
      <h2>Register</h2>
      {error && <p className="error-message">{error}</p>}
      {success ? <p>Registered successfully!</p> : null}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="User name"
          value={userName}
          onChange={(e) => setUserName(e.target.value)}
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Registering..." : "Register"}
        </button>
      </form>
      {/* Google sign-in registers on first use — same flow as the login page's button */}
      <GoogleSignInButton text="signup_with" />

      {/* ✅ Back to Login */}
      <p>Already have an account? <Link to="/">Login here</Link></p>
    </div>
  );
};

export default Register;
